import React from "react";

const AuthContext = React.createContext({
  userName: "",
  userType: "",
  handleLogout: () => {},
});

export default AuthContext;
